export default __webpack_public_path__ + "static/media/red_cancel_circle.3c52813b.svg";